export const trades = [
  { name: '' },
  { name: 'Copa' },
  { name: 'Welder' },
  { name: 'Electrician' },
  { name: 'Fitter' },
  { name: 'M.M.V' },
  { name: 'Wireman' },
  { name: 'R.A.C' },
  ]

